import { useState } from 'react'
import groLogo from '../images/GRObotic Logo-darkfull.png'

const STORAGE_KEY = 'staging_access_granted'

const StagingGate = ({ children }: { children: React.ReactNode }) => {
  const [granted, setGranted] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  // Only gate on staging — pass through on all other environments
  if (import.meta.env.VITE_ENV !== 'staging' || granted) {
    return <>{children}</>
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}/aws/staging-auth`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      })
      if (response.ok) {
        localStorage.setItem(STORAGE_KEY, 'true')
        setGranted(true)
      } else {
        setError('Invalid credentials')
      }
    } catch {
      setError('Could not reach the server. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <img src={groLogo} alt="GRObotic" style={styles.logo} />
        <div style={styles.badge}>STAGING ENVIRONMENT</div>
        <p style={styles.subtitle}>Authorised access only</p>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            style={styles.input}
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Verifying…' : 'Enter'}
          </button>
        </form>
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0f1117',
    zIndex: 9999,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#1a1d27',
    borderRadius: 12,
    padding: '48px 40px',
    width: 360,
    boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
  },
  logo: {
    width: 180,
    marginBottom: 24,
  },
  badge: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.12em',
    color: '#f59e0b',
    backgroundColor: 'rgba(245,158,11,0.12)',
    border: '1px solid rgba(245,158,11,0.3)',
    borderRadius: 4,
    padding: '4px 10px',
    marginBottom: 8,
  },
  subtitle: {
    color: '#6b7280',
    fontSize: 13,
    margin: '0 0 28px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    borderRadius: 6,
    border: '1px solid #2d3148',
    backgroundColor: '#0f1117',
    color: '#e5e7eb',
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box',
  },
  error: {
    color: '#ef4444',
    fontSize: 13,
    margin: 0,
    textAlign: 'center',
  },
  button: {
    marginTop: 4,
    padding: '10px 0',
    borderRadius: 6,
    border: 'none',
    backgroundColor: '#3b82f6',
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    width: '100%',
  },
}

export default StagingGate
